import pure from "./higher-order/pure";
import React from "react";

export default pure(({ movement }) => {
  if (movement > 0) {
    return <span className="leaderboard_movement leaderboard_movement--is-up" data-leaderboard-movement={movement} />;
  } else if (movement < 0) {
    return <span className="leaderboard_movement leaderboard_movement--is-down" data-leaderboard-movement={Math.abs(movement)} />;
  } else {
    return <span className="leaderboard_movement leaderboard_movement--no-change" />;
  }
});
